// The Slack app manifest a person copies into api.slack.com/apps (#601, #581 Q4).
//
// The manifest is the JSON file beside this one, and nothing here retypes any of it:
// its scopes are held to the ones the adapter's calls need by
// `tests/test_integration_setup.py`, which reads that same file.

import manifest from "./slack-app-manifest.json";

/** The manifest exactly as it is shown and copied. */
export const SLACK_MANIFEST_TEXT: string = JSON.stringify(manifest, null, 2);

/** The bot scopes the manifest asks for, for the sentence that names them. */
export const SLACK_MANIFEST_SCOPES: readonly string[] = manifest.oauth_config.scopes.bot;

/** Where a Slack app is made from a manifest. */
export const SLACK_APPS = "https://api.slack.com/apps?new_app=1";
